import React from 'react';
import PropTypes, { any } from 'prop-types';

import PopOverMenu from '../../components/PopOverMenu';
import Utr from '../../components/text/Utr';
import Img from '../../components/Img';
import { canPlayerBeAddedToDraw } from '../../utils/draws';
import { isPlayerCheckedIntoDraw } from '../../utils/events';
import { sportTypeIds } from '../../utils/eventConstants';

import styles from './drawEdit.scss';

const DrawTeamItemV2 = (props) => {
    const {
        teamId,
        player1,
        player2,
        isSelected,
        hidePopOverMenu,
        isWaitlist,
        placementString,
        isNotInDraw,
        showHighSchool,
        utrType,
        isReadOnly,
        teamHasResult,
        isPlaced,
        hasBackdraw,
        isBackdraw,
        toggleTeamSelect,
        organizerRatings,
        sportTypeId,
        drawId,
        displaySeedingOrder,
        handleTeamSeedOrderChanged,
        seedingManualOrder,
        setSeedingManualOrderTeam,
        'data-testid': dataTestId,
    } = props;

    const getHighSchoolName = () => {
        let description = player1?.highSchool ? `- ${player1.highSchool}` : '';
        if (player2?.highSchool && player2?.highSchool !== player1.highSchool) {
            description = player1?.highSchool ? `${description} / ${player2?.highSchool}` : player2?.highSchool;
        }
        return description;
    };

    const shortName = (player) => {
        return player && player.firstName && player.lastName ? `${player.firstName[0]}. ${player.lastName}` : null;
    };

    const fullName = (player) => {
        return player && player.firstName && player.lastName ? `${player.firstName} ${player.lastName}` : null;
    };

    const utr = (player) => {
        if (!player) {
            return '';
        }
        return <Utr sportTypeId={sportTypeId} player={player} pbrClass={styles.pbr} force={{ ratingType: 'doubles', utrType, showDecimals: true, doNotMask: true }} organizerRatings={organizerRatings} isOrganizerView={true} />;
    };
    const player1checkedIn = isPlayerCheckedIntoDraw(player1, drawId);
    const player2checkedIn = isPlayerCheckedIntoDraw(player2, drawId);
    const canAddTeamToDraw = canPlayerBeAddedToDraw(player1) && canPlayerBeAddedToDraw(player2);
    const title = !canAddTeamToDraw && 'Team is not registered in any division';

    const onTeamClick = () => {
        if (!isBackdraw && canAddTeamToDraw) {
            toggleTeamSelect(teamId);
        }
    };
    const seedOrder = seedingManualOrder.find((item) => item.teamId === teamId)?.seedNumber;

    return (
        <div
            className={`item d-flex align-items-center ${isPlaced ? 'placed' : ''} ${isSelected ? 'selected' : ''} ${!canAddTeamToDraw && styles.disabled}`}
            title={title}
            onClick={onTeamClick}
            data-testid={dataTestId}
        >
            {!isReadOnly && (
                <div className="checkbox-wrapper" data-testid={dataTestId && `${dataTestId}.checkbox`}>
                    {!isBackdraw && <div className={`checkbox-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>}
                </div>
            )}
            <div className="d-flex aic">
                {displaySeedingOrder && (
                    <input
                        type="number"
                        className="seeding-order d-flex aic jcc"
                        data-testid={dataTestId && `${dataTestId}.seed-input`}
                        onChange={(e) => {
                            e.stopPropagation();
                            const { value } = e.target;
                            if (value === '') {
                                setSeedingManualOrderTeam((prevOrder) => prevOrder.map((item) => (item.teamId === teamId
                                    ? { ...item, seedNumber: '' }
                                    : item)));
                            } else {
                                setSeedingManualOrderTeam((prevOrder) => prevOrder.map((item) => (item.teamId === teamId
                                    ? { ...item, seedNumber: value }
                                    : item)));
                            }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        onBlur={(e) => {
                            e.stopPropagation();
                            handleTeamSeedOrderChanged(teamId, e.target.value);
                        }}
                        value={seedOrder}
                    />
                )}
                <div className="player-details">
                    <div className="name" data-testid={dataTestId && `${dataTestId}.name`}>
                        <span className="text-dark" title={fullName(player1)} data-testid={dataTestId && `${dataTestId}.player1-name`}>
                            {shortName(player1)}
                        </span>&nbsp;<small data-testid={dataTestId && `${dataTestId}.player1-utr`}>{utr(player1)}</small>
                        {player1checkedIn && <span className="utr-icon icon-check-mark-green pl24 checkin-mark" title="Player checked in" />}
                        /
                        <span className="text-dark" title={fullName(player2)} data-testid={dataTestId && `${dataTestId}.player2-name`}>
                            {shortName(player2)}
                        </span>
                        &nbsp;<small data-testid={dataTestId && `${dataTestId}.player2-utr`}>{utr(player2)}</small>
                        {player2checkedIn && <span className="utr-icon icon-check-mark-green pl24 checkin-mark" title="Player checked in" />}
                    </div>
                    {isWaitlist
                        ? <div className="location" data-testid={dataTestId && `${dataTestId}.location`}>Team <span>{showHighSchool ? `${getHighSchoolName()}` : ''}</span></div>
                        : <div className="location" data-testid={dataTestId && `${dataTestId}.location`}>Team {showHighSchool ? `${getHighSchoolName()}` : ''} <span>{placementString ? `- ${placementString}` : ''}</span></div>}
                </div>
            </div>
            {(!hidePopOverMenu && !isReadOnly && (!teamHasResult || hasBackdraw || isNotInDraw)) && (
                <PopOverMenu
                    popOverMenuClass="flex-right"
                    horizontalEllipsis="true"
                    data-testid={dataTestId && `${dataTestId}.menu`}
                    menuItems={[
                        (!teamHasResult && !isNotInDraw && !isBackdraw && (isWaitlist
                            ? { value: 'not_placed', label: 'Not Placed', teamId }
                            : { value: 'waitlist', label: 'Waitlist', teamId })),
                        (hasBackdraw && !isNotInDraw && { value: 'backdraw', label: 'Add to Back Draw', teamId }),
                        (isNotInDraw && { value: 'addToDraw', label: 'Add to Draw', teamId }),
                        (!isNotInDraw && { value: 'tag', label: 'Tag Team', teamId }),
                    ]}
                    onSelected={props.handlePlayerPopoverClick}
                />
            )}
        </div>
    );
};

DrawTeamItemV2.propTypes = {
    teamId: PropTypes.string,
    player1: PropTypes.objectOf(any),
    player2: PropTypes.objectOf(any),
    isSelected: PropTypes.bool,
    hidePopOverMenu: PropTypes.bool,
    isWaitlist: PropTypes.bool,
    placementString: PropTypes.string,
    isNotInDraw: PropTypes.bool,
    showHighSchool: PropTypes.bool,
    utrType: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    teamHasResult: PropTypes.bool,
    isPlaced: PropTypes.bool,
    hasBackdraw: PropTypes.bool,
    isBackdraw: PropTypes.bool,
    toggleTeamSelect: PropTypes.func,
    organizerRatings: PropTypes.arrayOf(any),
    sportTypeId: PropTypes.number,
    drawId: PropTypes.string,
    displaySeedingOrder: PropTypes.bool,
    handleTeamSeedOrderChanged: PropTypes.func,
    seedingManualOrder: PropTypes.arrayOf(any),
    setSeedingManualOrderTeam: PropTypes.func,
    'data-testid': PropTypes.string,
};

DrawTeamItemV2.defaultProps = {
    teamId: '',
    player1: {},
    player2: {},
    isSelected: false,
    hidePopOverMenu: false,
    isWaitlist: false,
    placementString: '',
    isNotInDraw: false,
    showHighSchool: false,
    isReadOnly: false,
    teamHasResult: false,
    isPlaced: false,
    hasBackdraw: false,
    isBackdraw: false,
    toggleTeamSelect: () => {},
    organizerRatings: [],
    sportTypeId: sportTypeIds.TENNIS,
    drawId: '',
    displaySeedingOrder: false,
    handleTeamSeedOrderChanged: () => { },
    seedingManualOrder: [],
    setSeedingManualOrderTeam: () => { },
    'data-testid': undefined,
};

export default React.memo(DrawTeamItemV2);
